import { createReducer } from '../../../utils/';
import { combineReducers } from 'redux';
import constant from './constant';

const Messagehandlers = {
    [constant.TaskMessageGet](state, action) {
        return action.payload;
    },
};

const pageHandlers = {
    [constant.TaskMessageListPage](state, action) {
        return action.payload;
    },
};

const stateHandlers = {
    [constant.ListLoading](state, action) {
        return { ...state, loading: action.payload };
    },
};

const listHandlers = {
    [constant.TaskMessageListGET](state, action) {
        return action.payload;
    },
};

export const ListPage = createReducer({}, pageHandlers); // 分页信息
export const ListStatus = createReducer({ loading: false }, stateHandlers); // 列表状态
export const ListMessage = createReducer([], listHandlers); // 列表
// export const searchActiveListGet = createReducer([], Activehandlers);// 查询活动条件列表

export const messageList = combineReducers({
    ListMessage,
    ListPage,
    ListStatus,
});



// WEBPACK FOOTER //
// ./pages/user/taskMessage/reducers.js